// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-newsGrid-___newsGrid__container___2NmWk","title-box":"src-components-Admin-newsGrid-___newsGrid__title-box___3AoXp","search-box":"src-components-Admin-newsGrid-___newsGrid__search-box___2LZ2h","title":"src-components-Admin-newsGrid-___newsGrid__title___3x-Mq","button-box":"src-components-Admin-newsGrid-___newsGrid__button-box___PLuuo","client-box":"src-components-Admin-newsGrid-___newsGrid__client-box___E0-8n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/newsGrid/newsGrid.css
// module id = 1048
// module chunks = 0